import './bootstrap.js'


// WEBPACK FOOTER //
// ./src/plugin/index.js